import { magicBackBG } from "../../../../appAssets";
import "./RenderVideoViewer.scss";

interface RenderVideoViewerProps {
  videoPathUrl: string;
  onClose: () => void;
}

/**
 * Mirrors srcMobile/Screens/MagicBagPack/RenderVideoViewer/index.tsx
 * Full-screen video player with magicBackBG behind it.
 */
function RenderVideoViewer({ videoPathUrl, onClose }: RenderVideoViewerProps) {
  return (
    <div className="video-viewer" style={{ backgroundImage: `url(${magicBackBG})` }}>
      <div className="video-viewer__header">
        <div />
        <button
          type="button"
          className="video-viewer__close"
          onClick={onClose}
          aria-label="Close"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>

      <video
        className="video-viewer__video"
        src={videoPathUrl}
        controls
        autoPlay
        loop
        playsInline
      />
    </div>
  );
}

export default RenderVideoViewer;
